export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  isDetailed: true,
  detailRowComponent: 'mf-detail-row',
  isCheckable: false,
  stickeyHeaders: true,
  gutterOpts: {},
  isCardView: true,
  fields: [
    {
			name: 'viewBIM',
			width: '48px',
			title: '',
		},
    {
      name: 'field-generic-input',
      width: '400px',
      sticky: true,
      title: 'Object ID',
      prop: 'guid',
      id: 'guid',
      defaultVisible: true,
      searchable: true,
      inputProps: {
        type: 'text',
      },
    }, {
      name: 'field-generic-input',
      prop: 'objType',
      id: 'objType',
      width: '152px',
      title: 'Object Type',
      defaultVisible: true,
      searchable: true,
    },
  ],
};
